<template>
    <div class="program-editor">
        <bread-crumb :bread-list="breadList" />
        <div class="add-content">
            <div class="title-wrap">
                <i class="iconfont icon-tongyongbiaotiicon"></i>
                <span class="title-text">编辑栏目</span>
            </div>
            <el-form :model="programForm"
                     ref="programForm"
                     v-loading="loading"
                     label-width="104px"
                     class="banner-form">
                <el-form-item label="栏目名称"
                              prop="programName"
                              :rules="[{ required: true, message: '请输入栏目名称', trigger: 'change' }]">
                    <el-input v-model.trim="programForm.programName"
                              class="from-input"
                              placeholder="请输入栏目名称"
                              maxlength="50">
                    </el-input>
                </el-form-item>

                <el-form-item label="科室"
                              prop="departmentId"
                              :rules="[{ required: true, message: '请输入科室', trigger: 'change' }]">
                    <el-select filterable
                               clearable
                               remote
                               :remote-method="getHospitalDept"
                               :loading="searchLoading"
                               loading-text="正在搜索科室，请稍后..."
                               v-model="programForm.departmentId"
                               placeholder="请输入关键字搜索"
                               class="form-select"
                               @change="handleSelect"
                               @clear="handleSelect">
                        <el-option v-for="item in deptList"
                                   :label="item.groupName"
                                   :value="item.groupId"
                                   :key="item.groupId">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary"
                               class="submit-btn"
                               @click="submitForm('programForm')">提交</el-button>
                    <el-button @click="handleCandle"
                               class="cancle-btn">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { postListDepartment, getProgram, putProgram } from '@/api/program'
export default {
    name: 'programEditor',
    data () {
        return {
            breadList: [{ label: '运营管理' }, { label: '栏目管理', path: '/operation/program' }, { label: '编辑栏目' }],
            programForm: {
                programName: '',
                departmentId: '',
                departmentName: ''
            },
            loading: false,
            searchLoading: false,
            deptList: [],
            programId: this.$route.query.programId
        }
    },
    computed: {
        ...mapGetters([
            'userInfo'
        ])
    },
    methods: {
        handleCandle () {
            this.$router.push('/operation/program')
        },
        async getHospitalDept (value) {
            let params = {
                searchName: value,
                hospitalId: this.userInfo.hospitalId,
                current: 1,
                size: 100
            }
            this.deptList = []
            this.searchLoading = true
            const { results } = await postListDepartment(params)
            this.deptList = results
            this.searchLoading = false
        },

        handleSelect (value) {
            if (value) {
                let obj = {}
                obj = this.deptList.find((item) => {
                    return item.groupId === value
                })
                this.programForm.departmentName = obj.groupName
                this.programForm.departmentId = value
            } else {
                this.deptList = []
            }
        },
        submitForm (formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.handleUpdateProgram()
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        async handleUpdateProgram () {
            let params = {
                programId: this.programForm.programId,
                programName: this.programForm.programName,
                departmentId: this.programForm.departmentId,
                departmentName: this.programForm.departmentName
            }
            this.loading = true
            const { state } = await putProgram(params)
            this.loading = false
            if (state === 200) {
                this.$message({
                    message: '更新栏目信息成功',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '1000'
                })
                this.$router.push('/operation/program')
            }
        },
        async queryByProgramId () {
            this.loading = true
            const { results } = await getProgram(this.programId)
            this.programForm = JSON.parse(JSON.stringify(results))
            this.getDept(this.programForm.departmentName)
        },

        async getDept (value) {
            let params = {
                searchName: value,
                hospitalId: this.userInfo.hospitalId,
                current: 1,
                size: 100
            }
            this.deptList = []
            const { results } = await postListDepartment(params)
            this.deptList = results
            this.loading = false
        },
        init () {
            this.queryByProgramId()
        }

    },
    mounted () {
        this.init()
    }
}
</script>

<style lang="scss">
.program-editor {
    height: 100%;
    .add-content {
        min-height: calc(100% - 95px);
        box-shadow: 0 1px 4px 0 rgba(202, 202, 202, 0.5);
        margin: 20px;
        padding: 20px 20px 0 20px;
        background: #fff;
        .title-wrap {
            font-size: 0;
            padding-bottom: 20px;
            height: 16px;
            line-height: 16px;
            .icon-tongyongbiaotiicon {
                color: $color-primary;
                font-size: 16px;
                vertical-align: middle;
            }
            .title-text {
                font-size: 14px;
                color: #333333;
                margin-left: 10px;
                display: inline-block;
                height: 16px;
                line-height: 16px;
                vertical-align: middle;
            }
        }

        .banner-form {
            .el-form-item__label {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #666666;
                letter-spacing: 0;
                padding-right: 20px;
            }
            .el-form-item__content {
                .from-input {
                    width: 320px;
                    .el-input__inner {
                        border-radius: 3px;
                        border: 1px solid #dcdcdc;
                        height: 32px;
                        padding: 0 10px;
                    }
                }
                .form-select {
                    .el-input {
                        width: 320px;
                        .el-input__inner {
                            border-radius: 3px;
                            border: 1px solid #dcdcdc;
                            height: 32px;
                            padding: 0 10px;
                        }
                    }
                    .el-input__suffix {
                        .el-input__icon {
                            line-height: 32px;
                        }
                    }
                }

                .submit-btn {
                    width: 100px;
                    height: 32px;
                    border-radius: 3px;
                    padding: 0;
                }
                .cancle-btn {
                    width: 100px;
                    height: 32px;
                    border-radius: 3px;
                    padding: 0;
                    background: #f5f5f5;
                    border: 1px solid #cccccc;
                    color: #666;
                    margin-left: 16px;
                }
            }
        }
    }
}
</style>
